import type { Theme } from '../../types/theme';

export const shopifyTheme: Theme = {
  id: 'shopify',
  name: 'Shopify',
  description: 'Dark cinematic e-commerce platform with neon green accents',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/shopify/DESIGN.md',
  visualKeywords: ['dark', 'neon green', 'cinematic', 'e-commerce', 'bold'],
  colors: {
    background: '#0f0f0f',
    surface: '#1a1a1a',
    surfaceElevated: '#242424',
    textPrimary: '#ffffff',
    textSecondary: '#b8b8b8',
    textMuted: '#b8b8b8',
    border: '#333333',
    borderSubtle: '#3d3d3d',
    primary: '#96bf48',
    primaryHover: '#a5ce57',
    primaryActive: '#78a12a',
    accent: '#96bf48',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'low',
    tone: 'cinematic',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
